export default {
  /**
   * @return {boolean}
   */
  HasPermission: function(permission_key, reducer) {
    if (reducer.props.hasOwnProperty("permission")) {
      if (!reducer.props.permission) return false;

      return (
        reducer.props.permission.filter(function(permission_obj) {
          return permission_obj.codename === permission_key;
        }).length > 0
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/App/helper/user.js